export default {
    mounted(el, binding, vnode, prevVNode) {
        el.addEventListener('load', () => {
            el.contentWindow.postMessage({
                    element: el.id,
                    query: "height"
                },
                "https://twitframe.com");
        });
    }
}